import { User } from 'types';

export const getDefaultUserState = (): User => {
  return {
    empId: 0,
    company: '',
    companyCode: '',
    currentLocation: '',
    projDeptName: '',
    empNumber: '',
    occupation: '',
    startDate: '',
    empName: '',
    phone: '',
    passportNo: '',
    countryOrg: '',
    contact: null,
    email: null,
    extn: null,
    mobile: null,
    empImageName: null,
    reportingManager: null,
    status: null,
    isStaff: false,
  };
};
